import { render } from "./BenefitDetailModal.vue?vue&type=template&id=30c275eb&scoped=true"
import script from "./BenefitDetailModal.vue?vue&type=script&lang=js"
export * from "./BenefitDetailModal.vue?vue&type=script&lang=js"

import "./BenefitDetailModal.vue?vue&type=style&index=0&id=30c275eb&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c275eb"]])

export default __exports__